module.exports = __webpack_public_path__ + "img/key.6faa02d4.svg";